import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "onUpdate", "type"];
import * as React from 'react';
import cn from 'classnames';
import { safeInvoke } from '../../../../library';
export var HiddenInput = React.forwardRef(function (props, ref) {
  var handleChange = function handleChange(e) {
    var value = e.currentTarget.value;
    safeInvoke(props.onUpdate, props.field, value, e);
    safeInvoke(props.onChange, e);
  };
  var className = props.className,
    onUpdate = props.onUpdate,
    type = props.type,
    inputProps = _objectWithoutProperties(props, _excluded);
  var classNames = cn(className);
  return React.createElement("input", _extends({
    ref: ref,
    className: classNames,
    onChange: handleChange,
    type: "hidden"
  }, inputProps));
});
HiddenInput.displayName = 'HiddenInput';